const ClosedEyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_3470_26951)">
      <path
        d="M21 9C18.6 11.667 15.6 13 12 13C8.4 13 5.4 11.667 3 9"
        stroke="#A9AFBF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 15.0002L5.5 11.2002"
        stroke="#A9AFBF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.0003 14.9762L18.5083 11.2002"
        stroke="#A9AFBF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 17L9.5 13"
        stroke="#A9AFBF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.9998 17L14.4998 13"
        stroke="#A9AFBF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3470_26951">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ClosedEyeIcon;
